import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

export default function Settings() {
  const [info,    setInfo]    = useState(null);
  const [tab,     setTab]     = useState('Agency');
  const [saving,  setSaving]  = useState(false);
  const [message, setMessage] = useState('');
  const [error,   setError]   = useState('');

  const [agencyForm, setAgencyForm] = useState({ agencyName:'', gstin:'', pan:'', phone:'', email:'', address:'', gstRate:18, invoicePrefix:'INV', poPrefix:'PO', paymentAdvance:50, paymentInterim:25, paymentFinal:25 });
  const [credForm,   setCredForm]   = useState({ currentPassword:'', newUsername:'', newPassword:'', confirmPassword:'' });

  useEffect(() => {
    Promise.all([api.get('/settings'), api.get('/config')]).then(([s, c]) => {
      setInfo(s);
      setAgencyForm({
        agencyName:     c.agencyName     || '',
        gstin:          c.gstin          || '',
        pan:            c.pan            || '',
        phone:          c.phone          || '',
        email:          c.email          || '',
        address:        c.address        || '',
        gstRate:        c.gstRate        || 18,
        invoicePrefix:  c.invoicePrefix  || 'INV',
        poPrefix:       c.poPrefix       || 'PO',
        paymentAdvance: c.paymentTerms?.advance || 50,
        paymentInterim: c.paymentTerms?.interim || 25,
        paymentFinal:   c.paymentTerms?.final   || 25,
      });
    });
  }, []);

  function setAF(k,v) { setAgencyForm(f=>({...f,[k]:v})); }
  function setCF(k,v) { setCredForm(f=>({...f,[k]:v})); }

  async function handleSaveAgency() {
    setSaving(true); setMessage(''); setError('');
    try {
      await api.put('/config', agencyForm);
      setMessage('Agency details saved.');
    } catch(err) { setError(err.message); }
    finally { setSaving(false); }
  }

  async function handleSaveCredentials() {
    if (!credForm.currentPassword) { setError('Current password is required.'); return; }
    if (credForm.newPassword && credForm.newPassword !== credForm.confirmPassword) { setError('New passwords do not match.'); return; }
    setSaving(true); setMessage(''); setError('');
    try {
      await api.put('/config/credentials', credForm);
      setMessage('Login credentials updated.');
      setCredForm({ currentPassword:'', newUsername:'', newPassword:'', confirmPassword:'' });
    } catch(err) { setError(err.message); }
    finally { setSaving(false); }
  }

  async function handleBackup() {
    setSaving(true); setMessage(''); setError('');
    try {
      const result = await api.post('/settings/backup', {});
      setMessage(`Backup created: ${result.filename} (${result.size})`);
    } catch(err) { setError(err.message); }
    finally { setSaving(false); }
  }

  function handleExport() {
    window.open('/api/settings/export', '_blank');
  }

  const tabs = ['Agency', 'Login & Security', 'Backup & Export'];

  return (
    <div className="page-content">
      <div className="topbar"><div className="topbar-title">Settings</div></div>

      <div className="filter-tabs" style={{marginBottom:-4}}>
        {tabs.map(t => <button key={t} className={`filter-tab ${tab===t?'active':''}`} onClick={() => { setTab(t); setMessage(''); setError(''); }}>{t}</button>)}
      </div>

      {message && <div style={{background:'var(--success-bg)',color:'var(--success)',border:'1px solid #8fcfb0',borderRadius:'var(--radius-sm)',padding:'9px 14px',fontSize:12}}>{message}</div>}
      {error   && <div style={{background:'var(--danger-bg)', color:'var(--danger)', border:'1px solid #f5c4c4', borderRadius:'var(--radius-sm)',padding:'9px 14px',fontSize:12}}>{error}</div>}

      {/* Agency Tab */}
      {tab === 'Agency' && (
        <div className="card card-body" style={{display:'flex',flexDirection:'column',gap:12,maxWidth:560}}>
          <div style={{fontSize:13,fontWeight:700,color:'var(--text-dark)',marginBottom:4}}>Agency Details</div>
          <div className="form-group"><label className="form-label">Agency Name</label>
            <input className="form-input" value={agencyForm.agencyName} onChange={e=>setAF('agencyName',e.target.value)} /></div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">GSTIN</label><input className="form-input" value={agencyForm.gstin} onChange={e=>setAF('gstin',e.target.value)} /></div>
            <div className="form-group"><label className="form-label">PAN</label><input className="form-input" value={agencyForm.pan} onChange={e=>setAF('pan',e.target.value)} /></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Phone</label><input className="form-input" value={agencyForm.phone} onChange={e=>setAF('phone',e.target.value)} /></div>
            <div className="form-group"><label className="form-label">Email</label><input className="form-input" value={agencyForm.email} onChange={e=>setAF('email',e.target.value)} /></div>
          </div>
          <div className="form-group"><label className="form-label">Address</label><textarea className="form-textarea" value={agencyForm.address} onChange={e=>setAF('address',e.target.value)} rows={2} /></div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Default GST Rate (%)</label><input className="form-input" type="number" value={agencyForm.gstRate} onChange={e=>setAF('gstRate',e.target.value)} /></div>
            <div className="form-group"><label className="form-label">Invoice Prefix</label><input className="form-input" value={agencyForm.invoicePrefix} onChange={e=>setAF('invoicePrefix',e.target.value)} /></div>
            <div className="form-group"><label className="form-label">PO Prefix</label><input className="form-input" value={agencyForm.poPrefix} onChange={e=>setAF('poPrefix',e.target.value)} /></div>
          </div>
          <div className="form-group"><label className="form-label">Default Payment Terms (Advance / Interim / Final %)</label>
            <div className="form-row">
              <input className="form-input" type="number" value={agencyForm.paymentAdvance} onChange={e=>setAF('paymentAdvance',+e.target.value)} />
              <input className="form-input" type="number" value={agencyForm.paymentInterim} onChange={e=>setAF('paymentInterim',+e.target.value)} />
              <input className="form-input" type="number" value={agencyForm.paymentFinal}   onChange={e=>setAF('paymentFinal',  +e.target.value)} />
            </div></div>
          <div style={{textAlign:'right'}}><button className="btn btn-primary" onClick={handleSaveAgency} disabled={saving}>{saving?'Saving…':'Save Changes'}</button></div>
        </div>
      )}

      {/* Login & Security Tab */}
      {tab === 'Login & Security' && (
        <div className="card card-body" style={{display:'flex',flexDirection:'column',gap:12,maxWidth:420}}>
          <div style={{fontSize:13,fontWeight:700,color:'var(--text-dark)',marginBottom:4}}>Change Login Credentials</div>
          <div className="form-group"><label className="form-label">Current Password *</label>
            <input className="form-input" type="password" value={credForm.currentPassword} onChange={e=>setCF('currentPassword',e.target.value)} /></div>
          <div style={{borderTop:'1px solid var(--border-light)',paddingTop:10,marginTop:2}}>
            <div style={{fontSize:10,fontWeight:700,textTransform:'uppercase',letterSpacing:'0.5px',color:'var(--text-light)',marginBottom:10}}>Update (leave blank to keep current)</div>
            <div className="form-group" style={{marginBottom:10}}><label className="form-label">New Username</label>
              <input className="form-input" value={credForm.newUsername} onChange={e=>setCF('newUsername',e.target.value)} placeholder="Leave blank to keep current" /></div>
            <div className="form-group" style={{marginBottom:10}}><label className="form-label">New Password</label>
              <input className="form-input" type="password" value={credForm.newPassword} onChange={e=>setCF('newPassword',e.target.value)} placeholder="Leave blank to keep current" /></div>
            <div className="form-group"><label className="form-label">Confirm New Password</label>
              <input className="form-input" type="password" value={credForm.confirmPassword} onChange={e=>setCF('confirmPassword',e.target.value)} /></div>
          </div>
          <div style={{textAlign:'right'}}><button className="btn btn-primary" onClick={handleSaveCredentials} disabled={saving}>{saving?'Saving…':'Update Credentials'}</button></div>
        </div>
      )}

      {/* Backup & Export Tab */}
      {tab === 'Backup & Export' && (
        <div style={{display:'flex',flexDirection:'column',gap:12,maxWidth:480}}>
          <div className="card card-body">
            <div style={{fontSize:13,fontWeight:700,color:'var(--text-dark)',marginBottom:6}}>Database Backup</div>
            <p style={{fontSize:12,color:'var(--text-light)',marginBottom:12}}>Creates a timestamped copy of the database in the <code>data/</code> folder on the server.</p>
            <button className="btn btn-primary" onClick={handleBackup} disabled={saving}>{saving?'Creating…':'Create Backup Now'}</button>
          </div>

          <div className="card card-body">
            <div style={{fontSize:13,fontWeight:700,color:'var(--text-dark)',marginBottom:6}}>Export All Data</div>
            <p style={{fontSize:12,color:'var(--text-light)',marginBottom:12}}>Downloads all data as a JSON file. Includes clients, projects, vendors, payments, and subscriptions.</p>
            <button className="btn btn-outline" onClick={handleExport}>↓ Export JSON</button>
          </div>

          {info && (
            <div className="card card-body">
              <div style={{fontSize:11,fontWeight:700,textTransform:'uppercase',letterSpacing:'0.5px',color:'var(--text-light)',marginBottom:10}}>System Info</div>
              {[
                ['App Version',    info.version],
                ['Schema Version', `v${info.schemaVersion}`],
                ['Node.js',        info.nodeVersion],
                ['Database Size',  info.dbSize],
              ].map(([label, val]) => (
                <div key={label} style={{display:'flex',justifyContent:'space-between',fontSize:12,padding:'5px 0',borderBottom:'1px solid var(--border-light)'}}>
                  <span style={{color:'var(--text-light)'}}>{label}</span>
                  <span style={{fontWeight:600,color:'var(--text-dark)',fontFamily:'monospace'}}>{val}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
